"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RUM_IDENTITY_POOL_ID = exports.RUM_GUEST_ROLE_ARN = exports.RUM_APPLICATION_ID = void 0;
exports.RUM_APPLICATION_ID = (_a = process.env.NEXT_PUBLIC_RUM_APPLICATION_ID) !== null && _a !== void 0 ? _a : '7cf70799-db01-4af6-96ad-c4300a91ca91';
exports.RUM_GUEST_ROLE_ARN = (_b = process.env.NEXT_PUBLIC_RUM_GUEST_ROLE_ARN) !== null && _b !== void 0 ? _b : 'arn:aws:iam::796412268118:role/RUM-Monitor-us-east-1-796412268118-0857937497071-Unauth';
exports.RUM_IDENTITY_POOL_ID = (_c = process.env.NEXT_PUBLIC_RUM_IDENTITY_POOL_ID) !== null && _c !== void 0 ? _c : 'us-east-1:95dd38fd-1c4e-443f-a77b-7b80996edc50';
